import React from 'react';

import './index.module.less';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import CommonBtn from '@components/CommonBtn';
import FridayService from '@services/friday';

interface IProps {
  onClose: () => void;
  onSelect: (type: number) => void;
}

const GuardAreaTypeMenu = (props: IProps) => {
  const onSelectType = (type: number) => {
    FridayService.addEvent('security_guard_add_edit_guard_area_regional_nature_click', {type: (type === 1) ? '危险区域' : '安全区域'});
    props.onClose && props.onClose();
    props.onSelect && props.onSelect(type);
  }

  return (
    <HalfScreenInfoModal
      height="4.8rem"
      onClose={ props.onClose }
      hideCloseBtn={ true }
    >
      <div className='flex' styleName='menu-container'>
        <div className='flex' styleName='menu-item' onClick={() => onSelectType(2)}>安全区域</div>
        <div className='flex' styleName='menu-item' onClick={() => onSelectType(1)}>危险区域</div>
      </div>
      <CommonBtn
        type="fixed"
        btnText="取 消"
        onConfirm={ props.onClose }
        style={{ background: '#F2F4F7', color: '#55585C', fontSize: '.32rem', marginBottom: '.48rem' }}
      />
    </HalfScreenInfoModal>
  )
}

export default GuardAreaTypeMenu;